import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/timeoff`;
export const TimeOffAction = {
    find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: search}).then(res => {
            if (res.status === 200) {
                commit('SET_TIMEOFF_LIST', res.data.map(el => {
                    return {
                        ...el,
                        start_date: Constants.formatFromDate(el.start_date),
                        end_date: Constants.formatFromDate(el.end_date),
                    };
                }));
            }
        });
    },

    delete: ({commit, state}, id) => {
        return $http.delete(`${url}/${id}`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit('DELETE_TIMEOFF', id);
            }
        });
    },
    rollback: ({commit, state}, id) => {
        return $http.delete(`${url}/${id}/rollback`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit('DELETE_TIMEOFF', id);
            }
        });
    },

    info: ({commit, state}) => {
        return $http.get(`${url}/info`, state.authHeader);
    },

    add: ({commit, state}, data) => {
        return $http.post(url, data, state.authHeader);
    },

    edit: ({commit, state}, data) => {
        return $http.put(`${url}/${data.id}`, data.data, state.authHeader);
    },

    getByIdAndAggregation: ({commit, state}, id) => {
        return $http.get(`${url}/${id}?userAggregation=true`, state.authHeader);
    },

    get: ({commit, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },
    aggregate: ({commit, state}) => {
        return $http.get(`${url}/aggregate`, state.authHeader)
    }
};